import { createGlobalStyle } from 'styled-components/macro';

export const DefaultGlobals = createGlobalStyle`
  html {
    background-color: var(--c-bg);
    color: var(--c-bg--text);
  }
  html, body {
    /* iOS scrolling issue on ovelays */
    /* width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch; */

    /* For sidebar */
    /* &.noscroll {
    } */

    margin: 0;
    min-height: 100%;
    font: var(--f-body);
    font-family: var(--f-primary); /* Edge bug */
    line-height: var(--f-height);
    letter-spacing: var(--f-spacing);
  }

  body {
    /* overflow-y: scroll; */
    margin-bottom: 50px;
  }

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  img {
    max-width: 100%;
  }

  /* Normalize */
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    color: inherit;
  }

  a {
    color: var(--c-primary);
  }
`;

export default DefaultGlobals;
